import { useContext, useState} from 'react'
import {  Box, Grid, Flex } from 'theme-ui'
import { CanvasContext } from '../../hooks/LessonPage';
import {  Input,Typography,Button, Form } from 'antd';
import './UrlPanel.scss';

const { TextArea } = Input;
const { Title } = Typography;

function UrlPanel() {
  const [form] = Form.useForm();
  const variant = Form.useWatch('variant', form);
  const [formLayout, setFormLayout] = useState('vertical');
  const { state, actions } = useContext(CanvasContext);
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);
  const [fontSize, setFontSize] = useState('24');
  const [urlTitle, setUrlTitle] = useState('');
  const [urlLink, setUrlLink] = useState('');


  const onFinish = (values) => {
    console.log(values);
    var urlData = {urlLink : values.urlLink , urlTitle : values.urlTitle, isBold : isBold , isItalic : isItalic , isUnderline : isUnderline, fontSize : fontSize}
    var datastring = JSON.stringify(urlData);
    var data = {type : "URL", url : "", defaultcontent : datastring}
    actions?.addElement(data);  
    // var s = datastring;
  };

  return (
    <>
      {/* <Box sx={{ padding: '2rem 2rem 1rem' }}>
        <Input style={{ background: '#fff', color: '#333' }} type="tel" placeholder="Search text" />
        <button onClick={buttonClick}>Click Me</button>
      </Box> */}
      {/* <Box sx={{ padding: '0 2rem', color: '#fff', fontFamily: 'Lexend' }}>
        <Box sx={{ fontWeight: 500, fontSize: '2rem', padding: '0.8rem 0' }}>
          External Link
        </Box> */}
        <div style={{
            width: "100%",
            height: "50px",
            margin: "auto",
            justifyItems: "center",
            alignItems: "center",
            textAlign: "center",
            marginTop: "10px"      
        }}>
        <div style={{color : 'white' , fontWeight : 'bold', width : '100%', fontSize : '18px' }}>
            External Link
        </div>
            </div>                  
      {/* </Box> */}
      <div class="editor-container">
        <div class="toolbar">
            <button style={{background : isBold ? "#007bff" : "white"}} onClick={() => setIsBold(!isBold)}><b>B</b></button>
            <button style={{background : isItalic ? "#007bff" : "white"}} onClick={() => setIsItalic(!isItalic)}><i>I</i></button>
            <button style={{background : isUnderline ? "#007bff" : "white"}} onClick={() => setIsUnderline(!isUnderline)}><u>U</u></button>
            <select onChange={(e) => setFontSize(e.target.value)}>
                <option value="24">Normal</option>
                <option value="16">Small</option>
                <option value="36">Large</option>
                <option value="48">Huge</option>
            </select>
        </div>
    </div> 

      <Grid sx={{ gridTemplateRows: '50px 50px 50px' }}>
           {/* <Box sx={{ fontWeight: 600, fontSize: '2rem', margin : "1rem 1rem" }}>
              <Title style={{color : "white"}} level={5}>Enter Title : </Title>
              <Input style={{ marginBottom : "25px"}}  size="large" placeholder="Enter your title here"/>
              <Title style={{color : "white", paddingBottom : "15px"}} level={5}>Enter your external link :</Title>
              <TextArea rows={4} />
              <div style={{
                  width: "100%",
                  height: "50px",
                  margin: "auto",
                  justifyItems: "center",
                  alignItems: "center",
                  textAlign: "center",
                  marginTop: "10px"      
             }}>
            <Button type="primary">Add External Link</Button>
         </div>                 
           </Box> */}
           <Box sx={{ fontWeight: 600, fontSize: '2rem', margin : "1rem 1rem" }}>
           <Form
              layout={formLayout}
              form={form}
              initialValues={{
                layout: formLayout,
              }}
              style={{
                maxWidth: formLayout === 'inline' ? 'none' : 600,
              }}   
              onFinish={onFinish}           
            >     
            <Form.Item
              label="Enter title : "
              name="urlTitle"
              rules={[{ required: true, message: 'Please enter any value!' }]}
            >
              <Input  size="large" placeholder="Enter your title here"/>
            </Form.Item>              
            <Form.Item
              label="Enter your external link :"
              name="urlLink"
              rules={[{  pattern: new RegExp(/(https):\/\/([\w.]+\/?)\S*/), required: true, message: 'Please enter a valid link!' }]}
            >
              <Input.TextArea />
            </Form.Item>   

            <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>                  
         </Form>
         </Box>
      </Grid>
  
    </>
  )
}
export default UrlPanel
